<template>
    <div class="card mb-3">
        <div class="card-body">
            <div class="alert alert-primary" v-if="$store.state.userData.isOrganization && $store.state.userData.hasWallet">
                <p class="mb-0">میزان موجودی کیف پول : <b>{{ deposit }} ریال</b></p>
            </div>
            <router-link :to="{name: 'foreignBonusCards.create'}" class="btn btn-success ml-2">ثبت سفارش بن کارت</router-link>
            <router-link :to="{name: 'foreignBonusCards.charge'}" class="btn btn-primary ml-2">شارژ بن کارت</router-link>
            <router-link :to="{name: 'foreignBonusCards.requests'}" class="btn btn-secondary">لیست درخواست ها</router-link>
            <hr>
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :key="dataTableKey" :rows="rows" v-if="rows.length" :count="count" :url="'Organizations/Bonus/Tourism/Orders/Search'" :operations="['bonusCards',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Index',
    data(){
        return {
            columns: [
                {
                    title: 'شناسه',
                    field: 'orderId'
                },
                {
                    title: 'سازمان',
                    field: 'customerName'
                },
                {
                    title: 'وضعیت سفارش',
                    field: 'statusTitle'
                },
                {
                    title: 'نوع سفارش',
                    field: 'orderType'
                },
                {
                    title: 'مبلغ',
                    field: 'amount'
                },
                {
                    title: 'تاریخ',
                    field: 'createdAt'
                },
                {
                    title: 'ساعت',
                    field: 'createdAtTime'
                }
            ],
            rows: [],
            showLoading: true,
            deposit: 0,
            count: 0,
            dataTableKey: 0
        }
    },
    methods: {
        getData(){
            if(this.$store.state.userData.isOrganization){
                this.$api.get('Organizations/Wallet/Balance').then(({data}) => {
                    if(data.status)
                        this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.result);
                });
            }
            this.$api.post('Organizations/Bonus/Tourism/Orders/Search',{page: 1,perPage: 10}).then(({data}) => {
                if(data.status){
                    this.rows = [];
                    data.result.list.map(order => {
                        this.rows.push({
                            ...order,
                            fullName: order.firstName + ' ' + order.lastName,
                            amount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.amount) + ' ریال'
                        });
                    });
                    this.count = data.result.count;
                    this.rows.operations = ['foreignBonusCards',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                    this.dataTableKey += 1;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>